import api from './api'

export const therapyBookingService = {
  fetchList(params = {}) {
    const query = new URLSearchParams()
    if (params.status) query.append('status', params.status)
    if (params.therapistId) query.append('therapistId', params.therapistId)
    if (params.rescheduleStatus) query.append('rescheduleStatus', params.rescheduleStatus)
    query.append('page', params.page ?? 0)
    query.append('size', params.size ?? 10)
    return api.get(`/therapy/bookings?${query.toString()}`)
  },
  confirmPayment(id) {
    return api.patch(`/therapy/bookings/${id}/confirm-payment`)
  },
  approve(id, payload) {
    return api.patch(`/therapy/bookings/${id}/approve`, payload)
  },
  previewBatchApprove(payload) {
    return api.post('/therapy/bookings/batch-approve/preview', payload)
  },
  batchApprove(payload) {
    return api.post('/therapy/bookings/batch-approve', payload)
  },
  reject(id, reason) {
    return api.patch(`/therapy/bookings/${id}/reject`, null, { params: { reason } })
  },
  cancel(id, reason) {
    return api.patch(`/therapy/bookings/${id}/cancel`, null, { params: { reason } })
  },
  verify(id) {
    return api.patch(`/therapy/bookings/${id}/verify`)
  },
  complete(id) {
    return api.patch(`/therapy/bookings/${id}/complete`)
  },
  approveReschedule(id, payload = {}) {
    return api.patch(`/therapy/bookings/${id}/reschedule/approve`, payload)
  },
  rejectReschedule(id, reason) {
    return api.patch(`/therapy/bookings/${id}/reschedule/reject`, null, { params: { reason } })
  }
}
